/* Messekonkurrence 27 · /pages/konkurrence
   Validering, afsendelse til Klaviyo og personlig tak-besked — uden Shopify-formular
   og uden genindlæsning (ejer-krav 2026-09-25: ingen "Ny kundehenvendelse"-mail).
   Se docs/MESSEKONKURRENCE_KLAVIYO_2026_09.md før ændringer. */
(() => {
  const root = document.querySelector('[data-mk27]');
  if (!root) return;

  let cfg = {};
  try {
    cfg = JSON.parse(root.querySelector('[data-mk27-config]').textContent) || {};
  } catch (e) {
    cfg = {};
  }
  const msg = cfg.messages || {};
  const EMAIL_RE = /^\S+@\S+\.\S+$/;
  const SEND_TIMEOUT_MS = 12000;

  // Dansk talformat: komma er decimal, punktum er tusindtal ("4.200" = 4200).
  // Punktum efterfulgt af 1–2 cifre ("4.2", "328.50") læses som decimal.
  function parseGuess(raw) {
    const value = String(raw || '').replace(/[\s ]/g, '');
    if (!value) return null;
    let num = NaN;
    if (/^\d+(,\d{1,3})?$/.test(value) || /^\d{1,3}(\.\d{3})+(,\d{1,3})?$/.test(value)) {
      num = Number(value.replace(/\./g, '').replace(',', '.'));
    } else if (/^\d+\.\d{1,2}$/.test(value)) {
      num = Number(value);
    }
    return Number.isFinite(num) && num > 0 ? num : NaN;
  }
  const forDisplay = (num) => num.toLocaleString('da-DK', { maximumFractionDigits: 3 }); // 4.200 · 328,5

  // CTA: blød rulning til formularen (respekterer reduceret bevægelse).
  const reduceMotion = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-mk27-scroll]');
    if (!link || !link.hash) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
  });

  const form = root.querySelector('form[data-mk27-form]');
  const success = root.querySelector('[data-mk27-success]');
  if (!form) return; // fristen er udløbet: ingen formular
  const nameInput = form.querySelector('[data-mk27-name]');
  const emailInput = form.querySelector('[data-mk27-email]');
  const consentInput = form.querySelector('[data-mk27-consent]');
  const trapInput = form.querySelector('[name="website"]');
  const guessInputs = Array.from(form.querySelectorAll('[data-mk27-guess]'));
  const errorEl = form.querySelector('[data-mk27-error]');
  const submitBtn = form.querySelector('[data-mk27-submit]');
  const submitLabel = form.querySelector('[data-mk27-submit-label]');
  if (!nameInput || !emailInput || !errorEl || !submitBtn) return;

  const consentMode = cfg.consentMode || 'required';
  const idleLabel = submitLabel ? submitLabel.textContent : '';
  let invalidEl = null;
  let sending = false;
  submitBtn.disabled = false; // knappen er deaktiveret i HTML'en, indtil scriptet er klar

  function clearError() {
    if (!errorEl.hidden) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
    if (invalidEl) {
      invalidEl.removeAttribute('aria-invalid');
      invalidEl = null;
    }
  }
  function showError(text, el) {
    clearError();
    errorEl.textContent = text || '';
    errorEl.hidden = !text;
    if (el) {
      el.setAttribute('aria-invalid', 'true');
      invalidEl = el;
      el.focus();
    } else if (text) {
      errorEl.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
    }
  }
  function setBusy(busy) {
    sending = busy;
    submitBtn.disabled = busy;
    submitBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (submitLabel) submitLabel.textContent = busy && cfg.busyLabel ? cfg.busyLabel : idleLabel;
  }
  form.addEventListener('input', clearError);
  form.addEventListener('change', clearError);

  // Formularen sendes ALDRIG til serveren: al validering og afsendelse sker her.
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (sending) return;
    if (cfg.closeAt > 0 && Date.now() >= cfg.closeAt) {
      showError(msg.closed || 'Fristen er udløbet.');
      return;
    }

    const name = nameInput.value.trim();
    const email = emailInput.value.trim();
    if (!name) return showError(msg.name, nameInput);
    if (!EMAIL_RE.test(email)) return showError(msg.email, emailInput);

    const filled = guessInputs.filter((input) => input.value.trim());
    if (!filled.length) return showError(msg.guess, guessInputs[0]);
    const guesses = [];
    for (const input of filled) {
      const num = parseGuess(input.value);
      if (!(num > 0)) return showError(msg.number, input);
      guesses.push({
        number: input.dataset.number || '',
        label: input.dataset.label || input.name,
        key: input.dataset.key || input.dataset.label || input.name,
        unit: input.dataset.unit || '',
        num
      });
    }
    const consent = !!(consentInput && consentInput.checked);
    if (consentMode === 'required' && consentInput && !consent) return showError(msg.consent, consentInput);

    const entry = { name, email, guesses, consent, ts: Date.now() };

    // Honeypot udfyldt (bot): vis tak, men send intet.
    if (trapInput && trapInput.value) return showSuccess(entry);

    setBusy(true);
    sendToKlaviyo(entry).then((ok) => {
      if (ok) {
        showSuccess(entry);
      } else {
        setBusy(false);
        showError(msg.send || 'Dit gæt blev ikke sendt. Prøv igen.');
      }
    });
    return undefined;
  });

  function fillTemplate(node, vars) {
    if (!node) return;
    const tpl = node.getAttribute('data-mk27-tpl');
    if (!tpl) return;
    let text = vars.fornavn
      ? tpl.replace(/\[fornavn\]/g, vars.fornavn)
      : tpl.replace(/,?\s*\[fornavn\]/g, '');
    text = text.replace(/\[email\]/g, vars.email || 'din e-mail');
    node.textContent = '';
    text.split('\n').forEach((line, index) => {
      if (index) node.appendChild(document.createElement('br'));
      node.appendChild(document.createTextNode(line));
    });
  }

  function showSuccess(entry) {
    if (!success) return;
    const first = String(entry.name || '').trim().split(/\s+/)[0] || '';
    const vars = { fornavn: first, email: entry.email };
    fillTemplate(success.querySelector('[data-mk27-title]'), vars);
    fillTemplate(success.querySelector('[data-mk27-text]'), vars);
    const box = success.querySelector('[data-mk27-summary]');
    if (box && entry.guesses.length) {
      box.textContent = '';
      entry.guesses.forEach((guess) => {
        const row = document.createElement('div');
        row.className = 'mk27-sum';
        const label = document.createElement('span');
        label.textContent = [guess.number, guess.label].filter(Boolean).join(' · ');
        const value = document.createElement('strong');
        value.textContent = forDisplay(Number(guess.num)) + (guess.unit ? ' ' + guess.unit : '');
        row.append(label, value);
        box.appendChild(row);
      });
      box.hidden = false;
    }
    form.hidden = true;
    success.hidden = false;
    success.focus({ preventScroll: true });
    success.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
  }

  // Klaviyo (offentlig nøgle, ingen privat nøgle i browseren):
  //  1. client/subscriptions → listen MED samtykke — KUN når fluebenet er sat
  //  2. client/events → hændelsen med alle felter. Uden flueben bruges en anden hændelse
  //     (metricNoConsent), så flowet TwRzgR ikke lægger deltageren på listen.
  // Hændelsen ER registreringen: kun når den svarer 2xx, vises tak-beskeden.
  function sendToKlaviyo(entry) {
    const k = cfg.klaviyo || {};
    const metric = entry.consent ? k.metric : (k.metricNoConsent || '');
    if (!k.company || !metric || typeof window.fetch !== 'function') return Promise.resolve(false);
    const names = String(entry.name || '').trim().split(/\s+/).filter(Boolean);
    const source = k.source || 'Messekonkurrence';

    const profileProps = { [source]: true };
    const eventProps = {
      Konkurrence: cfg.contest || source,
      'Deltager i': entry.guesses.map((guess) => guess.key).join(' + '),
      'Antal gæt': entry.guesses.length,
      Navn: entry.name,
      Nyhedsmails: entry.consent ? 'Ja tak' : 'Nej tak',
      Samtykkefelt: { prechecked: 'forhåndsafkrydset', required: 'skulle krydses', optional: 'frivilligt' }[consentMode] || consentMode,
      Samtykketekst: cfg.consentText || '',
      'Indsendt (enhedens tid)': new Date(entry.ts).toISOString(),
      Side: window.location.pathname
    };
    entry.guesses.forEach((guess) => {
      const key = guess.unit ? `${guess.key} (${guess.unit})` : guess.key;
      eventProps[`Gæt · ${key}`] = guess.num;
      profileProps[`${source} · ${key}`] = guess.num;
    });
    const profile = { email: entry.email, properties: profileProps };
    if (names[0]) profile.first_name = names[0];
    if (names.length > 1) profile.last_name = names.slice(1).join(' ');

    const post = (path, data) => {
      const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      const timer = ctrl ? setTimeout(() => ctrl.abort(), SEND_TIMEOUT_MS) : 0;
      return window.fetch(`https://a.klaviyo.com/client/${path}/?company_id=${encodeURIComponent(k.company)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data }),
        keepalive: true,
        signal: ctrl ? ctrl.signal : undefined
      }).then((res) => {
        if (!res.ok) console.warn(`[messekonkurrence] Klaviyo ${path} svarede ${res.status}`);
        return res.ok;
      }).catch((err) => {
        console.warn(`[messekonkurrence] Klaviyo ${path} fejlede:`, err);
        return false;
      }).finally(() => clearTimeout(timer));
    };

    const calls = [];
    if (entry.consent && k.list) {
      calls.push(post('subscriptions', {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: profile } }
        },
        relationships: { list: { data: { type: 'list', id: k.list } } }
      }));
    }
    const eventCall = post('events', {
      type: 'event',
      attributes: {
        unique_id: `${entry.email}|${entry.ts}`,
        properties: eventProps,
        metric: { data: { type: 'metric', attributes: { name: metric } } },
        profile: { data: { type: 'profile', attributes: profile } }
      }
    });
    calls.push(eventCall);
    return Promise.all(calls).then(() => eventCall);
  }
})();
